import React from 'react';
import { makeStyles} from '@material-ui/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import AddIcon from '@material-ui/icons/Add';

import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import {priceFormat} from '../hooks/currency'; 
import { Button, Badge} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    //backgroundColor: 'yellow',
  },

  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
   // backgroundColor: 'red',
  },

  title: {
    display: 'flex',
    flexDirection: 'row',
    //backgroundColor: 'blue',
  },
  name: {
    marginLeft: theme.spacing(1),
    marginRight:  theme.spacing(1),
  },
  price: {
    marginLeft:'auto',
    marginRight:  theme.spacing(1),
  },

  description: {
    marginLeft: theme.spacing(1),
    marginRight:  theme.spacing(1),
  },

  endWithImage: {
    margin: theme.spacing(1, 1,2)
  },


  imageItem:{
    width: 100,
    borderWidth: 0,
    borderRadius: 16,
  },

  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
     alignItems: 'center',
    padding: theme.spacing(1),
  },

  cardControl: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    //backgroundColor: 'green',
  },

  paper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(2),
   
  },

  counter:{
    alignItems: 'center',
  },

  bascket: {
    alignItems: 'center',
    marginRight:  theme.spacing(1),
  },

  bascketItem: {
    display: 'flex',
    justifyContent: 'flex-end',
     alignItems: 'center',
  },

  divider: {
    marginLeft:"110px",
    margin: theme.spacing(1, 2,2,2),
    [theme.breakpoints.up('md')]: {
     margin: theme.spacing(2, 2,3,2)
     },
   },

   dividerNoImage: {
    margin: theme.spacing(1, 2,2,2),
    [theme.breakpoints.up('md')]: {
     margin: theme.spacing(2, 2,3,2)
     },
   },

   buttonNext: {
    minwidth: "50%",
    //marginLeft:"10%"
    padding: theme.spacing(1,4,1,4),
   },

   fatIcon: {
    marginRight:  theme.spacing(1),
    marginLeft:  theme.spacing(1),
    alignItems: 'center',
  },


}));

export default function ItemDelivery(props) {
  const classes = useStyles();
  const {orderList, setOrderList, onOrderListChange} = props; 
  const item = props.item; 
  const {currency,showCurrency,isTakingOrder, strings} = props; 
  const price = priceFormat(currency.style,item.price,showCurrency)

  const handlerOnAddService=(item)=>{
    setOrderList(prevOrder=>
      addItem(prevOrder,item)
    ); 
  }


  const addItem=(list,item)=>{
    let itemOrder = list.find(element => element.uid==item.uid); 
    if(!itemOrder){
        itemOrder = {}; 
        itemOrder.uid = item.uid; 
        itemOrder.count=1; 
        itemOrder.name =item.name;
        itemOrder.price = item.price;
        itemOrder.type = item.type; 
        list.push(itemOrder);
    }
    onOrderListChange(list,item);
    return list;
  }





  return (
    <div >
    <Card className={classes.card} elevation={0}>
     {props.showImage && item.image?
     <div>
        <img  className ={classes.imageItem} src={item.image} alt={"image"} />
     </div>
     : ""
     }

      <div className={classes.details}>
        <div>
          <div className={classes.title}>

            <div className={classes.name}>  
                <Typography variant="subtitle1" color="textPrimary">
                    {item.name}
                </Typography>
            </div>

            <div className={classes.price}>  
            <Typography variant="body2" color="textPrimary">
                    {price}
            </Typography>
            </div>
          </div>
        </div>
        <div className={classes.description}>
          <Typography variant="body2" color="textSecondary">
              {item.description}
          </Typography>
        </div>

        { isTakingOrder &&  item.price && item.price.length >0 && 
        <div className={classes.controls}>
            <Button  
                 variant="contained" 
                 color="accent"
                 size='large' 
                 className={classes.buttonNext } 
                 onClick = {()=>handlerOnAddService(item)}       
                 >

                  {strings.action_request}
                
                 </Button>
                 
        </div>
        }
     </div>
    </Card>

    { props.showImage && item.image ?
      <div  className={classes.divider}> 
      <Divider/>
      </div>
      :
      <div  className={classes.dividerNoImage}> 
      <Divider/>
      </div>
    }

    </div>
  );
}